import {
  Ch1AdditionalSupplyModal,
  Ch1BaseIncomeModal,
  Ch1CityCaptureModal,
  Ch1CombatResultsModal,
  Ch1ConstructionModal,
  Ch1MeleeDamageModal,
  Ch1MeleeRulesModal,
  Ch1MovementModal,
  Ch1RerollModal,
  Ch1RoundPhasesModal,
  Ch1SetupQuarterModal,
  Ch1SizeRecruitmentModal,
  Ch1SupplyModal,
  Ch1UndoButtonModal,
  Ch1UndoPhasesModal,
  Ch1UnitTypesModal,
  Ch1WarPhaseButtonModal,
  Ch1WarPhaseModal,
  Ch1WelcomeModal,
  Ch1WinPointsModal
} from './modals/chapter1Modals';
import {
  Ch2ArsenalModal,
  Ch2BarracksGrowthModal,
  Ch2CampGrowthModal,
  Ch2CampModal,
  Ch2CaptureCityModal,
  Ch2CavalryToBarracksModal,
  Ch2DeepRaidModal,
  Ch2EnemyInterceptedModal,
  Ch2FactionCardsModal,
  Ch2FarmChainModal,
  Ch2GarrisonBrokenModal,
  Ch2InterceptModal,
  Ch2MineBlockedModal,
  Ch2NewCityModal,
  Ch2NewCityQuarterModal,
  Ch2OrcResilienceModal,
  Ch2PalaceModal,
  Ch2QuarterZoneModal,
  Ch2RevengePlanModal,
  Ch2RulesHintModal,
  Ch2SteppeStepModal,
  Ch2SupplyShortageModal,
  Ch2SupplyToEmptyModal,
  Ch2WarehouseModal,
  Ch2WelcomeModal
} from './modals/chapter2Modals';
import {
  Ch3AdditionalSupplyModal,
  Ch3CaptureCityModal,
  Ch3CatapultGrowthModal,
  Ch3CatapultModal,
  Ch3CatapultVsFortressModal,
  Ch3DamagedBuildingModal,
  Ch3EnemyPolicyModal,
  Ch3FortressAssaultModal,
  Ch3FortressDefenseModal,
  Ch3FortressDestroyedModal,
  Ch3FortressModal,
  Ch3GuildInfluenceModal,
  Ch3CellInfoModal,
  Ch3GuildUniqueModal,
  Ch3ManeuverModal,
  Ch3PolicyMarketModal,
  Ch3PolicyShownModal,
  Ch3RerollModal,
  Ch3RoadIncomeModal,
  Ch3RulesPoliciesModal,
  Ch3ShotHitsAllModal,
  Ch3TempleModal,
  Ch3VentoryBonusModal,
  Ch3WelcomeModal
} from './modals/chapter3Modals';
import BarbaReplicaModal from './BarbaReplicaModal/BarbaReplicaModal';
import {TUTORIAL_BARBA_MODAL_IDS} from '../../configs/tutorial/tutorialBarbaReplicas';

/**
 * Маппинг идентификаторов обучающих модалок (из конфигов глав) на компоненты.
 * Идентификатор коротко отражает смысл: chN_<тема>.
 */
export const TUTORIAL_MODALS_REGISTRY = {
  // Реплики Барбы в начале глав (chN_barba_M): все окна — один компонент,
  // текст он берет по идентификатору открытой модалки
  ...Object.fromEntries(TUTORIAL_BARBA_MODAL_IDS.map((modalId) => [modalId, BarbaReplicaModal])),

  ch1_welcome: Ch1WelcomeModal,
  ch1_setup_quarter: Ch1SetupQuarterModal,
  ch1_round_phases: Ch1RoundPhasesModal,
  ch1_construction: Ch1ConstructionModal,
  ch1_base_income: Ch1BaseIncomeModal,
  ch1_undo_button: Ch1UndoButtonModal,
  ch1_undo_phases: Ch1UndoPhasesModal,
  ch1_war_phase: Ch1WarPhaseModal,
  ch1_war_phase_button: Ch1WarPhaseButtonModal,
  ch1_unit_types: Ch1UnitTypesModal,
  ch1_size_recruitment: Ch1SizeRecruitmentModal,
  ch1_supply: Ch1SupplyModal,
  ch1_additional_supply: Ch1AdditionalSupplyModal,
  ch1_win_points: Ch1WinPointsModal,
  ch1_movement: Ch1MovementModal,
  ch1_melee_rules: Ch1MeleeRulesModal,
  ch1_combat_results: Ch1CombatResultsModal,
  ch1_reroll: Ch1RerollModal,
  ch1_melee_damage: Ch1MeleeDamageModal,
  ch1_city_capture: Ch1CityCaptureModal,

  ch2_welcome: Ch2WelcomeModal,
  ch2_rules_hint: Ch2RulesHintModal,
  ch2_faction_cards: Ch2FactionCardsModal,
  ch2_supply_shortage: Ch2SupplyShortageModal,
  ch2_warehouse: Ch2WarehouseModal,
  ch2_enemy_intercepted: Ch2EnemyInterceptedModal,
  ch2_cavalry_to_barracks: Ch2CavalryToBarracksModal,
  ch2_barracks_growth: Ch2BarracksGrowthModal,
  ch2_camp_growth: Ch2CampGrowthModal,
  ch2_new_city: Ch2NewCityModal,
  ch2_quarter_zone: Ch2QuarterZoneModal,
  ch2_new_city_quarter: Ch2NewCityQuarterModal,
  ch2_steppe_step: Ch2SteppeStepModal,
  ch2_supply_to_empty: Ch2SupplyToEmptyModal,
  ch2_mine_blocked: Ch2MineBlockedModal,
  ch2_farm_chain: Ch2FarmChainModal,
  ch2_arsenal: Ch2ArsenalModal,
  ch2_intercept: Ch2InterceptModal,
  ch2_revenge_plan: Ch2RevengePlanModal,
  ch2_orc_resilience: Ch2OrcResilienceModal,
  ch2_deep_raid: Ch2DeepRaidModal,
  ch2_palace: Ch2PalaceModal,
  ch2_camp: Ch2CampModal,
  ch2_garrison_broken: Ch2GarrisonBrokenModal,
  ch2_capture_city: Ch2CaptureCityModal,

  ch3_welcome: Ch3WelcomeModal,
  ch3_policy_market: Ch3PolicyMarketModal,
  ch3_policy_shown: Ch3PolicyShownModal,
  ch3_rules_policies: Ch3RulesPoliciesModal,
  ch3_enemy_policy: Ch3EnemyPolicyModal,
  ch3_guild_influence: Ch3GuildInfluenceModal,
  ch3_cell_info: Ch3CellInfoModal,
  ch3_guild_unique: Ch3GuildUniqueModal,
  ch3_temple: Ch3TempleModal,
  ch3_road_income: Ch3RoadIncomeModal,
  ch3_ventory_bonus: Ch3VentoryBonusModal,
  ch3_catapult: Ch3CatapultModal,
  ch3_catapult_growth: Ch3CatapultGrowthModal,
  ch3_fortress: Ch3FortressModal,
  ch3_damaged_building: Ch3DamagedBuildingModal,
  ch3_fortress_assault: Ch3FortressAssaultModal,
  ch3_fortress_defense: Ch3FortressDefenseModal,
  ch3_shot_hits_all: Ch3ShotHitsAllModal,
  ch3_additional_supply: Ch3AdditionalSupplyModal,
  ch3_catapult_vs_fortress: Ch3CatapultVsFortressModal,
  ch3_reroll: Ch3RerollModal,
  ch3_maneuver: Ch3ManeuverModal,
  ch3_fortress_destroyed: Ch3FortressDestroyedModal,
  ch3_capture_city: Ch3CaptureCityModal,
};
